import { Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";

const Currency = () => {
  const [currencies, setCurrencies] = useState([]);
  const [addCurrency, setAddCurrency] = useState();
  const [btnLoading, setBtnLoading] = useState(false);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const updatedValue =
      e.target.name === "shortform"
        ? e.target.value.toUpperCase()
        : e.target.value;
    setAddCurrency({ ...addCurrency, [e.target.name]: updatedValue });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  useEffect(() => {
    fetchCurrencies();
  }, []);

  const fetchCurrencies = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/currency`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setCurrencies(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const data = addCurrency || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.name)) newErrors.name = "Currency Name is required";
    if (isEmpty(data.shortform)) {
      newErrors.shortform = "Currency Code is required";
    } else if (data.shortform.length !== 3) {
      newErrors.shortform = "Currency Code must be of 3 characters";
    }
    if (isEmpty(data.symbol)) newErrors.symbol = "Currency Symbol is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddCurrency = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/currency`,
        {
          name: addCurrency.name,
          shortform: addCurrency.shortform,
          symbol: addCurrency.symbol,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setAddCurrency("");
      fetchCurrencies();
    } catch (err) {
      console.error(err);
    } finally {
      setBtnLoading(false);
    }
  };
  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <div className="dashboard-container">
        <h2>Add Currency</h2>
        <div style={{ display: "flex", columnGap: 25 }}>
          <div style={{ width: "100%" }}>
            <input
              className={`${errors.name && "input-error"}`}
              type="text"
              name="name"
              id="name"
              placeholder="Currency Name"
              value={addCurrency && addCurrency.name}
              onChange={handleChange}
            />
            {errors.name && <p className="error">{errors.name}</p>}
          </div>
          <div style={{ width: "100%" }}>
            <input
              className={`${errors.shortform && "input-error"}`}
              type="text"
              name="shortform"
              id="shortform"
              placeholder="Currency Code (3 characters)"
              value={addCurrency && addCurrency.shortform}
              onChange={handleChange}
            />
            {errors.shortform && <p className="error">{errors.shortform}</p>}
          </div>
          <div style={{ width: "100%" }}>
            <input
              className={`${errors.symbol && "input-error"}`}
              type="text"
              name="symbol"
              id="symbol"
              placeholder="Currency Symbol"
              value={addCurrency && addCurrency.symbol}
              onChange={handleChange}
            />
            {errors.symbol && <p className="error">{errors.symbol}</p>}
          </div>
        </div>
        <div className="btn-container">
          <Button
            sx={{ margin: "5px 0 20px 0 !important" }}
            className="btn-contained"
            onClick={handleAddCurrency}
          >
            Add
          </Button>
        </div>

        <h2 style={{ marginTop: "30px" }}>All Currencies</h2>
        <table
          border={1}
          style={{
            borderCollapse: "collapse",
            width: "100%",
            textAlign: "center",
          }}
        >
          <thead>
            <tr>
              <th style={{ padding: "20px", width: "25%" }}>Currency</th>
              <th style={{ width: "25%" }}>Code</th>
              <th style={{ width: "25%" }}>Symbol</th>
            </tr>
          </thead>
          <tbody>
            {currencies.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  style={{ padding: "20px", textAlign: "center" }}
                >
                  No currencies added yet.
                </td>
              </tr>
            ) : (
              currencies.map((item) => (
                <tr key={item.id}>
                  <td style={{ padding: "20px" }}>{item.name}</td>
                  <td>{item.shortform}</td>
                  <td>{item.symbol}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Currency;
